import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class CampaignAnalyticsService {
    constructor(private http: HttpClient) {}

    getCampaignsWithLiveHistory(search = null) {
        if (search != null) {
            return this.http.get(
                `${environment.apiUrl}/campaign/analytics/get-campaigns-with-live-history?search=${search}`
            );
        }

        return this.http.get(
            `${environment.apiUrl}/campaign/analytics/get-campaigns-with-live-history`
        );
    }

    getCampaignAnalyticsOverview(params) {
        return this.http.post<any>(
            `${environment.apiUrl}/campaign/analytics/get-campaign-analytics-overview`,
            params
        );
    }

    getFilteredCampaignDetails(params) {
        return this.http.post<any>(
            `${environment.apiUrl}/campaign/analytics/get-filtered-details`,
            params
        );
    }

    getEstimatedFactorAndSpentOverTime(params) {
        return this.http.post<any>(
            `${environment.apiUrl}/campaign/analytics/get-estimated-factor-and-spent-over-time`,
            params
        );
    }

    getFactorDistributionAcrossChannels(params) {
        return this.http.post<any>(
            `${environment.apiUrl}/campaign/analytics/get-factor-distribution-across-channels`,
            params
        );
    }
}
